<template>
    <nav class="side-nav card">
        <div>
            <div>
                <!-- Nav items -->
                <ul class="navbar-nav-custom">
                    <li
                        class="nav-items"
                        :class="linkIsActive('/withdraw') ? 'active' : ''"
                    >
                        <div class="nav-link" @click="redirectLink('withdraw')">
                            <i class="ni ni-money-coins mr-3"></i>
                            <span class="nav-link-text">{{
                                $store.state.language === "en"
                                    ? "Withdraw"
                                    : "ငွေထုတ်"
                            }}</span>
                        </div>
                    </li>
                    <li
                        class="nav-items"
                        :class="linkIsActive('/deposit') ? 'active' : ''"
                    >
                        <div class="nav-link" @click="redirectLink('deposit')">
                            <i class="ni ni-credit-card mr-3"></i>
                            <span class="nav-link-text">{{
                                $store.state.language === "en"
                                    ? "Deposit"
                                    : "ငွေသွင်း"
                            }}</span>
                        </div>
                    </li>
                    <li
                        class="nav-items"
                        :class="linkIsActive('/history') ? 'active' : ''"
                    >
                        <div class="nav-link" @click="redirectLink('history')">
                            <i class="ni ni-folder-17 mr-3"></i>
                            <span class="nav-link-text">{{
                                $store.state.language === "en"
                                    ? "History"
                                    : "ငွေ မှတ်တမ်းများ"
                            }}</span>
                        </div>
                    </li>
                    <li
                        class="nav-items"
                        :class="
                            linkIsActive('/betslip-history') ? 'active' : ''
                        "
                    >
                        <div
                            class="nav-link"
                            @click="redirectLink('betslip-history')"
                        >
                            <i class="ni ni-single-copy-04 mr-3"></i>
                            <span class="nav-link-text">{{
                                $store.state.language === "en"
                                    ? "Betslip History"
                                    : "ဘောက်ချာများ"
                            }}</span>
                        </div>
                    </li>
                </ul>
                <!-- Divider -->
                <hr class="my-3" />
                <!-- Navigation -->
                <ul class="navbar-nav-custom mb-md-3">
                    <li class="nav-items">
                        <div
                            class="nav-link active active-pro"
                            @click="logout()"
                        >
                            <i
                                v-if="!isLoggingOut"
                                class="ni ni-lock-circle-open text-danger mr-3"
                            ></i>
                            <Loading
                                v-else
                                class="mr-3"
                                size="16"
                                color="#ee0a24"
                            />
                            <span class="nav-link-text text-danger">{{
                                isLoggingOut
                                  ? ($store.state.language === "en"
                                      ? "Logging out..."
                                      : "ထွက်နေသည်...")
                                  : ($store.state.language === "en"
                                      ? "Log Out"
                                      : "ထွက်မည်")
                            }}</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>
<script>
import { Toast, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Loading },
  data() {
    return {
      isLoggingOut: false,
    };
  },
  methods: {
    ...mapActions(['logoutUser']),
    /* example link = '/settings' */
    linkIsActive(link) {
      const paths = Array.isArray(link) ? link : [link];
      const res = paths.some(
        (path) => this.$route.path.indexOf(path) === 0,
      );
      if (res) {
        return true;
      }
      return false;
    },
    redirectLink(link) {
      this.$router.push(`/${link}`).catch(() => {});
    },
    async logout() {
      if (this.isLoggingOut) return;
      this.isLoggingOut = true;
      try {
        await this.logoutUser();
        Toast.success(
          this.$store.state.language === 'en'
            ? 'Logged out!'
            : 'ထွက်ပြီးပြီ',
        );
        this.$router.push('/welcome');
      } catch (error) {
        this.isLoggingOut = false;
      }
    },
  },
};
</script>
